import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faX } from '@fortawesome/free-solid-svg-icons';
import { ReactComponent as ResurgensLogo } from '../../assets/images/Resurgens-Logo.svg';
import './Loader.css';

const Loader = () => {
  return (
    <div className="loader-container">
      {/* <div className="loader"></div> */}

      <span className="loader-content">
        {/* <FontAwesomeIcon icon={faX} size="2xl" beatFade /> */}
        <ResurgensLogo
          role="img"
          aria-label="Resurgens Security Services Admin Portal Logo"
          width="80px"
          height="80px"
        />
      </span>
      {/* <span>Loading</span> */}
    </div>
  );
};

export default Loader;
